import { Heading } from '@youversion/design-system-components';
import React from 'react';

interface HeaderProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  title: React.ReactNode | string;
}

export default function Header({ left, right, title }: HeaderProps) {
  return (
    <div className='h-8 pli-2 plb-2 flex justify-between items-center relative'>
      <div className='relative z-1'>{left}</div>
      <div className='absolute inset-0 flex justify-center items-center'>
        <Heading size='xs' variant='headline'>
          {title}
        </Heading>
      </div>
      <div className='relative z-1'>{right}</div>
    </div>
  );
}
